export const ENGINEERING = {
  ROOT: '/engineering',
};
